const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'

export const safeRedirectPath = (value: unknown): string | null => {
  if (typeof value !== 'string' || value.length === 0) return null
  if (!value.startsWith('/') || value.startsWith('//')) return null
  if (value.includes('\\') || value.includes('://')) return null
  return value
}

export const rememberPostLoginRedirect = (path: string) => {
  const redirectTo = safeRedirectPath(path)
  if (!redirectTo) return
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectTo)
}

export const consumePostLoginRedirect = (): string | null => {
  const redirectTo = safeRedirectPath(
    sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY),
  )
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  return redirectTo
}
